import { useState } from 'react';
import { faqs } from '@/mocks/siteData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              关于开云体育app下载的常见疑问解答
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="font-medium text-foreground-900 text-sm md:text-base pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-200 flex-shrink-0 ${
                    openIndex === index
                      ? 'bg-primary-500 text-background-50 rotate-45'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className="ri-add-line text-sm w-4 h-4 flex items-center justify-center"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                  }`}
                >
                  <div className="px-6 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}